export const themes = {
  live: {
    flag: 'https://cdn.shopify.com/static/images/flags/dk.svg',
    store: 'dea-kudibal.myshopify.com',
    url: 'https://deakudibal.dk',
    country: 'Denmark',
    currency: 'DKK',
    international: false,
  },
  international: {
    flag: 'https://cdn.shopify.com/static/images/flags/eu.svg',
    store: 'dea-kudibal-international.myshopify.com',
    country: 'International',
    url: 'https://deakudibal.com',
    currency: 'EUR',
    international: true,
  },
  norway: {
    flag: 'https://cdn.shopify.com/static/images/flags/no.svg',
    store: 'dea-kudibal-no.myshopify.com',
    country: 'Norway',
    url: 'https://deakudibal.no',
    currency: 'NOK',
    international: false,
  },
  germany: {
    flag: 'https://cdn.shopify.com/static/images/flags/de.svg',
    store: 'dea-kudibal-de.myshopify.com',
    country: 'Germany',
    url: 'https://deakudibal.de',
    currency: 'EUR',
    international: false,
  },
  uk: {
    flag: 'https://cdn.shopify.com/static/images/flags/uk.svg',
    store: 'dea-kudibal-uk.myshopify.com',
    country: 'United Kingdom',
    url: 'https://deakudibal.co.uk',
    currency: 'GBP',
    international: false,
  },
}
